import { createContext, useContext } from 'react';
import type { ZapisIzPerepiski } from '../doski/api';

/**
 * ⛔ `s677`: КТО ОТКРЫВАЕТ «ЗАПИСАТЬ» РЯДОМ С ПЕРЕПИСКОЙ — очередь, карточка лида,
 * доска. Отдельным файлом, чтобы переписка (и лайт-вход `chat`) не тянула за
 * собой сетку журнала. Нет поставщика — прежний путь в журнал.
 */
export const ZapisRyadomContext = createContext<((z: ZapisIzPerepiski) => void) | null>(null);

export function useZapisRyadom(): ((z: ZapisIzPerepiski) => void) | null {
  return useContext(ZapisRyadomContext);
}
